<template>
  <div
    class="vm-helperLinkTo-container"
  >
    <template v-if="historyBack" >
      <a
        class="back-link"
        href="javascript:void(0)"
        @click="backToHistory()"
      >
        <font-awesome-icon
          size="1x"
          :icon="['fas', 'arrow-circle-left']"
        />
        <span>{{ $t("VMX.back_to_previous_page") }}</span>
      </a>
    </template>
    <template v-else>
      <a
        class="back-link"
        href="javascript:void(0)"
        @click="browserback()"
      >
        <font-awesome-icon
          size="1x"
          :icon="['fas', 'arrow-circle-left']"
        />
       <span>{{ $t("VMX.back_to_previous_page") }}</span>
      </a>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import instancesStateMixins from '../mixins/instanceStateMixins'
import componentControlMixins from '../mixins/componentControlMixins'
import EventBus from '~/states/event-bus'

export default {
  inheritAttrs: false,
  mixins: [instancesStateMixins, componentControlMixins],
  computed: {
    ...mapGetters({
      configForKey: 'config/configForKey',
    }),
    historyBack() {
      return this.configForKey('app_config').config[0].defaults?.historyBack || this.history.length > 1
    },
  },
  // mounted() {
    // this.showBackButton = true
    // if(localStorage.getItem('disableBack') === 'true') this.showBackButton = false
    // window.addEventListener('rerenderBack', this.receiveMessage)
    // window.addEventListener('disableBack', this.receiveMessage)
  // },
  // activated() {
    // this.showBackButton = true
    // if(localStorage.getItem('disableBack') === 'true') this.showBackButton = false
    // window.addEventListener('rerenderBack', this.receiveMessage)
    // window.addEventListener('disableBack', this.receiveMessage)
  // },
  // data() {
  //   return {
      // showBackButton: true,
  //   }
  // },
  methods: {
    ...mapActions({
      deleteHistory: 'instancesState/removeHistory',
    }),
    // receiveMessage(event) {
    //   if (event.detail.message === 'rerenderBack') {
    //     this.showBackButton = true
    //   }

    //   if (event.detail.message === 'disableBack') {
    //     this.showBackButton = false
    //   }
    // },
    browserback() {
      window.history.back()
      // localStorage.setItem('wentBack', true)
    },
    backToHistory() {
      EventBus.$emit('historyBack', true)
      this.deleteHistory()
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss" scoped>
.vm-helperLinkTo-container {
  display: flex;
  width: 100%;
  padding: .5rem 0;

  .back-link{
    white-space: nowrap;
    color: var(--back-link);
  }

  .presentation__navigation{
    flex-basis: 100%;
  }
}

</style>
